import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "body", "filterInput", "emptyRow", "freqBtn"]
  static values  = { freq: { type: String, default: "maturity" } }

  connect() {
    this.sortCol = null
    this.sortDir = null
  }

  toggleFreq() {
    this.freqValue = this.freqValue === "maturity" ? "monthly" : "maturity"
    const isMonthly = this.freqValue === "monthly"

    // Update button labels
    this.freqBtnTargets.forEach(btn => {
      btn.querySelectorAll("[data-freq-label]").forEach(el => {
        el.classList.toggle("font-semibold", el.dataset.freqLabel === this.freqValue)
        el.classList.toggle("text-content-primary", el.dataset.freqLabel === this.freqValue)
        el.classList.toggle("text-content-muted", el.dataset.freqLabel !== this.freqValue)
      })
    })

    // Show/hide rate display spans and update sort values
    this.bodyTarget.querySelectorAll("tr:not([data-empty-row]) td[data-maturity-val]").forEach(td => {
      td.querySelectorAll("[data-freq-show]").forEach(el => {
        el.classList.toggle("hidden", el.dataset.freqShow !== this.freqValue)
      })
      const val = isMonthly ? (td.dataset.monthlyVal || "0") : (td.dataset.maturityVal || "0")
      td.dataset.sortValue = val
    })
  }

  sort(event) {
    const th = event.currentTarget
    const col = parseInt(th.dataset.col)

    if (this.sortCol === col) {
      this.sortDir = this.sortDir === "desc" ? "asc" : "desc"
    } else {
      this.sortCol = col
      this.sortDir = col === 0 ? "asc" : "desc"
    }

    this.headerTargets.forEach(h => h.querySelector(".sort-icon")?.remove())

    const icon = document.createElement("span")
    icon.className = "sort-icon ml-1 text-primary-500"
    icon.textContent = this.sortDir === "asc" ? "↑" : "↓"
    th.appendChild(icon)

    const rows = Array.from(this.bodyTarget.querySelectorAll("tr:not([data-empty-row])"))

    rows.sort((a, b) => {
      const aVal = a.cells[col]?.dataset.sortValue ?? ""
      const bVal = b.cells[col]?.dataset.sortValue ?? ""

      const aNum = parseFloat(aVal)
      const bNum = parseFloat(bVal)
      const numeric = !isNaN(aNum) && !isNaN(bNum)

      let cmp = numeric ? aNum - bNum : aVal.localeCompare(bVal)
      return this.sortDir === "asc" ? cmp : -cmp
    })

    rows.forEach(row => this.bodyTarget.appendChild(row))
  }

  filter() {
    const raw = this.filterInputTarget.value.replace(/,/g, "").trim()
    const depositCents = raw === "" ? null : Math.round(parseFloat(raw) * 100)

    const rows = Array.from(this.bodyTarget.querySelectorAll("tr:not([data-empty-row])"))
    let visibleCount = 0

    rows.forEach(row => {
      const minCents = parseInt(row.dataset.minDepositCents ?? "0")
      const show = depositCents === null || minCents <= depositCents
      row.classList.toggle("hidden", !show)
      if (show) visibleCount++
    })

    if (this.hasEmptyRowTarget) {
      this.emptyRowTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }
}
